import { createSlice } from "@reduxjs/toolkit";


const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        items: {}
    },
    reducers: {
        addItem: (state, action) => {
            if (state.items[action.payload.id]) {
                state.items[action.payload.id]["count"] = ++state.items[action.payload.id]["count"];
            } else {
                state.items[action.payload.id] = { ...action.payload, count: 1 };
            }
        },
        removeItem: (state, action) => {
            if (state.items[action.payload.id].count > 1) {
                state.items[action.payload.id]["count"] = --state.items[action.payload.id]["count"];
            } else {
                delete state.items[action.payload.id];
            }
        }
    }
})

export const { addItem, removeItem } = cartSlice.actions
export default cartSlice.reducer;